import type { PulseEvent } from '../pulseSchema';

/** Fields never sent to GA4 (policy + payload size). */
export const GA4_STRIPPED_PARAM_KEYS = new Set([
  'email',
  'phone_number',
  'click_payload',
  'client_id',
  'session_id',
]);

/** GA4 allows 25 event parameters per hit. */
export const GA4_MAX_EVENT_PARAMS = 25;

const serializeGa4Value = (value: unknown): string | number | boolean | undefined => {
  if (value === null || value === undefined) return undefined;
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return value;
  }
  if (typeof value === 'object') {
    try {
      return JSON.stringify(value);
    } catch {
      return undefined;
    }
  }
  return String(value);
};

/** Map Pulse envelope → gtag event params for the dedicated GA4 property. */
export const pulseEnvelopeToGa4Params = (
  envelope: PulseEvent
): Record<string, string | number | boolean> => {
  const params: Record<string, string | number | boolean> = {};

  for (const [key, value] of Object.entries(envelope)) {
    if (key === 'event_name') continue;
    if (GA4_STRIPPED_PARAM_KEYS.has(key)) continue;
    const serialized = serializeGa4Value(value);
    if (serialized !== undefined) {
      params[key] = serialized;
    }
  }

  const keys = Object.keys(params);
  if (keys.length <= GA4_MAX_EVENT_PARAMS) {
    return params;
  }

  const trimmed: Record<string, string | number | boolean> = {};
  for (const key of keys.slice(0, GA4_MAX_EVENT_PARAMS)) {
    trimmed[key] = params[key];
  }
  return trimmed;
};
